module.exports = __webpack_public_path__ + "assets/img/Type E (85).68c82fcc.jpg";